export default __webpack_public_path__ + "static/media/kds_positivo.4ac7db95.webp";